{
  "id": "cnaes",
  "nome": "IBGE CNAE 2.3 Subclasses",
  "fonte": "IBGE API v2 /cnae/subclasses",
  "endpoints": [
    "https://servicodados.ibge.gov.br/api/v2/cnae/subclasses"
  ],
  "capturadoEm": "2026-08-05",
  "atualizadoEm": "2026-08-05T05:40:32.917Z",
  "contagens": {
    "cnaes": 1332
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-04"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-05T05:40:32.917Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#cnae-economic-activity"
}
